import React, { useContext, useEffect, useRef, useState, useCallback, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import moment from "moment";
import { IoChevronDownCircleOutline } from "react-icons/io5";

// Services
import {
  dispatchIndentApi,
  getAllBranchDropdwon,
  getAllVehicleNumber,
  indentCountApi,
  indentListApi,
  updateBranchIndentApi,
  updateMarketVisiblityApi,
} from "_services";

// Components
import { ButtonHeading, CustomPagination, CustomSelect } from "components";
import CustomTooltip from "components/CustomTooltip/CustomTooltip";

// Modals
import {
  AddEditModal,
  AddIndentModal,
  ConfirmModalFor,
  EbillExtentionModal,
  IndentAndBidDetailModal,
} from "modals";
import MastersFilterModal from "modals/MastersFilterModal";

// Utils & Context
import { UserContext } from "context";
import { actionPermission, utils } from "helper";
import useDocumentTitle from "hooks/useDocumentTitle";
import { API, AppConfig } from "lib";
import { StorageServices } from "utils";
import StorageService from "utils/StorageServices/StorageServices";
import images from "constants/images";
import { constant } from "constants/constant";
import AddIndentModal2 from "modals/AddIndentModal/AddIndentModal2";

const Plan = () => {
  const navigate = useNavigate();
  let isToken = localStorage.getItem("token");
  const TRIP_LABEL = "Trip";

  const { masterData, setDispatchIndent, dispatchIndent, allMenu, planFilter, setPlanFilter, setVehicleDetails } =
    useContext(UserContext);

  const planPermission = allMenu?.find((i) => i?.label === "Plan");
  const childsUser = useMemo(() =>
    allMenu?.find((i) => i?.label === TRIP_LABEL),
    [allMenu]
  );
  const [showAddIndent, setShowAddIndent] = useState(false);
  const [showPlanDetail, setShowPlanDetail] = useState(false);
  const [indentList, setIndentList] = useState([]);
  const [indentCount, setIndentCount] = useState([]);
  const [responseList, setResponseList] = useState([]);
  const [filter, setFilter] = useState({
    start_date: "",
    end_date: "",
    plan_status: "",
    bid_status: "",
    responses: "",
    limit: 25,
    offset: 1,
    search: "",
    consignor_id: "",
    branch_id: "",
    from_location: "",
    to_location: "",
    vehicle_id: "",
    firm_id: ""
  });

  const itemsPerPage = 25;
  const [totalItems, setTotalItems] = useState(0);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [listData, setListData] = useState({
    consignorList: [],
    branchList: [],
    vehicleList: [],
  });

  const [indentId, setIndentId] = useState("");
  const [activeTabStatus, setActiveTabStatus] = useState(0);
  const [showBackModal, setShowBackModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  const [isOpenBranchModal, setIsOpenBranchModal] = useState(false);
  const [isOpenVehicleModal, setIsOpenVehicleModal] = useState(false);
  const [excelLoading, setExcelLoading] = useState(false);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const prevPlanFilterRef = useRef();
  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    messageType: null,
    templateId: null,
    templateData: {}
  });

  useDocumentTitle("Plan | T360");

  useEffect(() => {
    getMasterDetails();
  }, [masterData]);



  const noTransactionStyle = {
    textAlign: "center",
    color: "#999",
    fontStyle: "italic",
    padding: "10px",
  };

  useEffect(() => {
    const prevPlanFilter = prevPlanFilterRef.current;

    if (
      JSON.stringify(prevPlanFilter) !== JSON.stringify(planFilter) &&
      planFilter?.company_id
    ) {
      const filteredValues = Object.entries(planFilter)
        .filter(
          ([key, val]) =>
            key !== "offset" &&
            key !== "limit" &&
            key !== "company_id" &&
            key !== "plan_status" &&
            key !== "bid_status" &&
            key !== "responses" &&
            key !== "branch_name" &&
            key !== "consignor_name" &&
            key !== "supplier_name" &&
            key !== "driver_name" &&
            key !== "vehicle_no" &&
            key !== "firm_id" &&
            key !== "search" &&
            val !== "" &&
            val !== null &&
            val !== undefined &&
            val !== 0
        )
        .map(([_, val]) => val);

      setFilterCount(filteredValues.length);
      getIndentList(planFilter);
      setFilter(planFilter);
      prevPlanFilterRef.current = planFilter;
    }
  }, [planFilter]);

  useEffect(() => {
    getIndentCount(planFilter);
  }, [planFilter?.consignor_id, planFilter?.branch_id, planFilter?.start_date, planFilter?.end_date, planFilter?.search, planFilter?.from_location, planFilter?.to_location, planFilter?.vehicle_id]);

  useEffect(() => {
    if (
      indentCount?.plan_status?.length > 0 &&
      planFilter?.plan_status != 1 &&
      (planFilter?.bid_status === undefined || planFilter?.responses === undefined)
    ) {
      setPlanFilter((prevFilter) => ({
        ...prevFilter,
        bid_status: 0,
        responses: 0,
      }));
    }
  }, [indentCount]);

  useEffect(() => {
    if (planFilter?.plan_status) {
      setPlanFilter((prevFilter) => ({
        ...prevFilter,
        bid_status: 0,
        responses: 0,
      }));
    }
  }, [planFilter?.plan_status]);

  useEffect(() => {
    if (totalItems !== undefined && totalItems !== null && isDataLoaded) {
      if (totalItems <= 25) {
        setPlanFilter((p) => ({ ...p, offset: 1 }));
      }
    }
  }, [totalItems, isDataLoaded]);

  const fetchUsers = async (search, page, limit) => {
    const res = await getAllVehicleNumber({
      company_id: StorageService.getCompanyId(),
      offset: page,
      limit,
      search,
    });
    if (res?.responseCode === 200) {
      const list = res?.data?.vehicle_list?.map((i) => ({
        ...i,
        name: `${i?.vehicle_no}`,
        ownershipStatus: i?.vehicle_ownership,
      }));
      return {
        items: list,
        total: res?.data?.total_record,
      };
    } else {
      toast.error(res?.responseMessage);
    }
  };

  const fetchBranch = async (search, page, limit) => {
    try {
      const res = await getAllBranchDropdwon({
        company_id: StorageService.getCompanyId(),
        offset: page,
        limit,
        search,
      });

      if (res?.responseCode === 200) {
        const list = res?.data?.branch_list.map((i) => ({
          ...i,
          name: i?.branch,
          label: i?.branch,
          value: i?._id
        }));

        return {
          items: list,
          total: res?.data?.total_record,
        };
      } else {
        toast.error(res?.responseMessage);
      }
    } catch (error) {
      toast.error("Error fetching drivers");
      return { items: [], total: 0 };
    }
  };

  const getIndentList = async (planFilter) => {
    const payload = {
      ...planFilter,
      start_date: planFilter?.start_date
        ? moment(planFilter?.start_date).format("YYYY-MM-DD")
        : "",
      end_date: planFilter?.end_date
        ? moment(planFilter?.end_date).format("YYYY-MM-DD")
        : "",
      firm_id: StorageService?.getFirmId()
    };

    try {
      const res = await indentListApi(payload);

      if (res?.responseCode == 200) {
        const resdata = res?.data?.plan_list?.map((i) => {
          return { ...i, visiblity: 0 };
        });
        setIndentList(resdata);
        setTotalItems(res?.data?.total_record);
        setIsDataLoaded(true);
      } else {
        toast.error(res?.responseMessage);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const getIndentCount = async (planFilter) => {
    const payload = {
      company_id: StorageService?.getCompanyId(),
      branch_id: planFilter?.branch_id,
      consignor_id: planFilter?.consignor_id,
      vehicle_id: planFilter?.vehicle_id,
      start_date: planFilter?.start_date
        ? moment(planFilter?.start_date).format("YYYY-MM-DD")
        : "",
      end_date: planFilter?.end_date
        ? moment(planFilter?.end_date).format("YYYY-MM-DD")
        : "",
      search: planFilter?.search,
      from_location: planFilter?.from_location,
      to_location: planFilter?.to_location,
      firm_id: StorageService?.getFirmId()
    };

    try {
      const res = await indentCountApi(payload);

      if (res?.responseCode == 200) {
        setIndentCount(res?.data);
      } else {
        toast.error(res?.responseMessage);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const getMasterDetails = () => {
    const list = masterData?.plan_responses_list?.map((i) => {
      return {
        label: i?.name,
        value: i?.id,
      };
    });
    setResponseList(list);
  };

  const togglePlanDetail = (id, status) => {
    setIndentId(id);
    setShowPlanDetail(true);
    setActiveTabStatus(status);
  };

  const handleFilter = (id, title) => {
    if (title == "plan") {
      if (id !== planFilter?.plan_status) {
        setPlanFilter({ ...planFilter, plan_status: id });
      }
    }

    if (title == "bid") {
      if (id !== planFilter?.bid_status) {
        setPlanFilter({ ...planFilter, bid_status: id });
      }
    }

    if (title == "responses") {
      if (id !== planFilter?.responses) {
        setPlanFilter({ ...planFilter, responses: id });
      }
    }
  };

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, offset: page }));
    setPlanFilter((s) => ({ ...s, offset: page }));
  };

  const planFromLoc = (loc) => {
    return loc.map((item) => item.from_city).join(" + ");
  };

  const planToLoc = (loc) => {
    return loc.map((item) => item.to_city).join(" + ");
  };

  const callAllApi = () => {
    getIndentCount(planFilter);
    getIndentList(planFilter);
    setIndentId("");
  };

  const handleEditIndent = (id) => {
    setIndentId(id);
    setShowAddIndent(true);
  };

  const handleDispatch = async () => {
    const payload = {
      company_id: StorageService.getCompanyId(),
      plan_id: showBackModal,
    };

    try {
      setLoading(true);
      const res = await dispatchIndentApi(payload);

      if (res?.responseCode == 200) {
        setShowBackModal(false);
        setDispatchIndent(res?.data?.plan);
        navigate("/trip/addtrip/createtrip2");
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const updateMarketVisiblity = async (data) => {
    const payload = {
      company_id: StorageService?.getCompanyId(),
      plan_id: data?._id,
      is_allow_visibility: data?.is_allow_visibility == false ? 1 : 0,
    };
    try {
      const res = await updateMarketVisiblityApi(payload);

      if (res?.responseCode == 200) {
        getIndentList(planFilter);
        toast.success(res?.responseMessage);
      } else {
        getIndentList(planFilter);
        toast.error(res?.responseMessage);
      }
    } catch (error) {
      getIndentList(planFilter);
      toast.error(error);
    }
  };

  const exportHandle = async () => {
    setExcelLoading(true);
    try {
      const payload = {
        company_id: StorageService.getCompanyId(),
        start_date: moment(planFilter.start_date).format("YYYY-MM-DD"),
        end_date: moment(planFilter.end_date).format("YYYY-MM-DD"),
        branch_id: planFilter?.branch_id,
        consignor_id: planFilter?.consignor_id,
        from_location: planFilter?.from_location,
        to_location: planFilter?.to_location,
        plan_status: planFilter?.plan_status,
        bid_status: planFilter?.bid_status,
        responses: planFilter?.responses,
      };
      const response = await fetch(
        `${AppConfig.api_baseurl}${API.PLAN_EXPORT_EXCEL_REPORT}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Token: `${isToken}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "transport360_plan.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      setExcelLoading(false);
    } catch (error) {
      setExcelLoading(false);
    }
  };

  const clearFilter = () => {
    setFilter((pre) => ({
      ...pre,
      start_date: "",
      end_date: "",
      search: "",
      consignor_id: "",
      branch_id: "",
      plan_status: 1,
      responses: 0,
      bid_status: 0,
      vehicle_id: "",
      from_location: "",
      to_location: ""
    }));

    setPlanFilter((pre) => ({
      ...pre,
      start_date: "",
      end_date: "",
      search: "",
      consignor_id: "",
      branch_id: "",
      plan_status: 1,
      responses: 0,
      bid_status: 0,
      vehicle_id: "",
      vehicle_no: null,
      from_location: "",
      to_location: ""
    }));

    setVehicleDetails({})
    setFilterCount(0);
  };

  const chnagePlanStatus = async (data, indent) => {
    const payload = {
      company_id: StorageServices?.getCompanyId(),
      plan_id: indent?._id,
      branch_id: "",
      vehicle_id: "",
      lorry_type_id: "",
      vehicle_type_id: "",
      responses: data?.value,
    };

    const res = await updateBranchIndentApi(payload);
    if (res.responseCode === 200) {
      callAllApi();
    }
  };

  const handlePermissionCallTrip = async (i) => {
    await actionPermission({
      company_id: StorageService.getCompanyId(),
      type: constant?.USABILITY_CONFIG_TYPES?.TRIP,
      onSuccess: () => setShowBackModal(i),
      setModalConfig
    });
  };

  const backModalProps = {
    show: showBackModal,
    closeModal: (e) => setShowBackModal(false),
    title: "Dispatch Indent",
    submitTitle: "Confirm",
    onSubmit: handleDispatch,
    confirmModal: "confirmModal",
    icon: images.TRUCKICON,
    disabled: loading,
    isLoadding: loading,
  };

  let openBranchModal = {
    isOpen: isOpenBranchModal,
    closeModal: (e) => setIsOpenBranchModal(false),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Update Branch",
    submitTitle: "Update Branch",
    footerPart: true,
    isLabelData: "Branch",
    placeholder: "Select Branch",
    ApiPoint: updateBranchIndentApi,
    callBackApi: callAllApi,
    branchList: listData?.branchList,
    titleName: "branch",
    fetchUsers: fetchBranch
  };

  let openVehicleModal = {
    isOpen: isOpenVehicleModal,
    closeModal: (e) => setIsOpenVehicleModal(false),
    modalMainClass: "_dashCommon_Modal _smModal",
    modalTitle: "Vehicle",
    submitTitle: "Update Vehicle",
    footerPart: true,
    isLabelData: "Vehicle",
    placeholder: "Select Vehicle",
    ApiPoint: updateBranchIndentApi,
    callBackApi: callAllApi,
    branchList: listData?.vehicleList,
    titleName: "Vehicle",
    fetchUsers: fetchUsers
  };

  let ebillExpProps = {
    isOpen: modalConfig.isOpen,
    closeModal: () => setModalConfig(prev => ({ ...prev, isOpen: false })),
    onSubmit: (e) => setModalConfig(prev => ({ ...prev, isOpen: false })),
    modalMainClass: " _dashCommon_Modal __actionPermissionModal _smModal",
    headerPart: true,
    floatCrossBtn: true,
    submitTitle: "Send Enquiry",
    messageType: modalConfig.messageType,
    templateId: modalConfig.templateId,
    templateData: modalConfig.templateData
  };

  return (
    <>
      <ButtonHeading
        title="Indent"
        onClick={() => setShowAddIndent(!showAddIndent)}
        buttonTitle={planPermission?.create === 1 ? "Add Indent" : ""}
        onExportClick={() => exportHandle()}
        exportbuttonTitle={"Export"}
        onClickFilterModal={(e) => setShowFilterModal(true)}
        excelLoading={excelLoading}
        filter={filter}
        setFilter={setFilter}
        showSearchFilter={{
          search: true,
          filterOption: true,
          filterCount: true,
        }}
        filterCount={filterCount}
        clearFilter={clearFilter}
      />
      <div className="_indentView_flx">
        <div className="indentSide_bx">
          <div className="_indtsLs_flx">
            <div className="_indtsList">
              <h5>PLAN STATUS</h5>
              <ul className="nav nav-tabs" id="myIndentTab" role="tablist">
                {indentCount?.plan_status?.map((item) => (
                  <li className="nav-item" role="presentation" key={item.id}>
                    <button
                      className={`nav-link ${planFilter?.plan_status === item.id ? "active" : ""
                        }`}
                      id={`${item.name.toLowerCase().replace(/\s+/g, "-")}-tab`}
                      data-bs-toggle="tab"
                      data-bs-target={`#${item.name
                        .toLowerCase()
                        .replace(/\s+/g, "-")}-tab-pane`}
                      type="button"
                      role="tab"
                      aria-controls={`${item.name
                        .toLowerCase()
                        .replace(/\s+/g, "-")}-tab-pane`}
                      aria-selected={planFilter?.plan_status === item.id}
                      onClick={() => handleFilter(item.id, "plan")}
                    >
                      <span>{item.name}</span> <span>{item.count}</span>
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            {planFilter?.plan_status == 1 && (
              <>
                <div className="_indtsList">
                  <h5>BIDS</h5>
                  <div className="_bidsLs_flx">
                    {indentCount?.bid_status?.map((bid) => {
                      return (
                        <div className="_bidsList" key={bid.id}>
                          <input
                            className="form-check-input _avPointer"
                            id={`bid-${bid.id}`}
                            type="radio"
                            name="bidList"
                            checked={planFilter?.bid_status === bid.id}
                            onChange={() => handleFilter(bid.id, "bid")}
                            disabled={planFilter?.plan_status != 1}
                          />
                          <label htmlFor={`bid-${bid.id}`}>
                            <span>{bid.name}</span>
                            <span>{bid.count}</span>
                          </label>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="_indtsList">
                  <h5>RESPONSES</h5>
                  <div className="_bidsLs_flx">
                    {indentCount?.responses?.map((bid) => {
                      return (
                        <div className="_bidsList" key={bid.id}>
                          <input
                            className="form-check-input _avPointer"
                            id={`responses-${bid.id}`}
                            type="radio"
                            name="responseList"
                            checked={planFilter?.responses === bid.id}
                            onChange={() => handleFilter(bid.id, "responses")}
                            disabled={planFilter?.plan_status != 1}
                          />
                          <label htmlFor={`responses-${bid.id}`}>
                            <span>{bid.name}</span>
                            <span>{bid.count}</span>
                          </label>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>

        <div className="_indTabl_right">
          <div className="_indentTable _planLTable">
            <div className="accordion" id="indentTableAccordian">
              <table className="__tPlain_table">
                <thead>
                  <tr>
                    <th>Indent Date</th>
                    <th>Indent No.</th>
                    <th>Trip</th>
                    <th>Firm</th>
                    <th>Party</th>
                    <th>From Station</th>
                    <th>To Station</th>
                    <th>Branch Name</th>
                    <th>Vehicle</th>
                    <th>Fleet Type</th>
                    <th>Material Type</th>
                    <th>View</th>
                  </tr>
                </thead>
                {indentList.length > 0 ? <>{indentList?.map((indent, index) => {

                  return (
                    <tbody className="accordion-item" key={index}>
                      <tr
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEditIndent(indent?._id);
                        }}
                      >
                        <td>
                          <div className="_dateNtime _pDate">
                            <p className="_tblText_inDent">
                              {indent?.indent_date
                                ? utils?.formatDateMonth(indent?.indent_date)
                                : "-"}
                            </p>
                            <p className="_lgtText_inDent">
                                {utils?.formatTimeWithoutConvertnew(indent?.indent_date)}
                            </p>
                          </div>
                        </td>

                        <td>
                          <p className="_tblText_inDent curser_pointer">
                            {indent?.indent_number
                              ? indent?.indent_number
                              : "-"}
                          </p>
                        </td>
                        <td>
                          <Link
                            className=""
                            onClick={(e) =>
                              navigate(
                                `/trip/addtrip/dispatched/${indent?.trip_id?._id}`
                              )
                            }
                          >
                            {indent?.trip_id?.trip_number
                              ? `${indent?.trip_id?.trip_number}`
                              : " - "}{" "}
                          </Link>
                        </td>
                        <td>
                          {(() => {
                            const name = indent?.firm_id?.firm || "-";
                            const value = String(name);

                            return value.length > 20 ? (
                              <CustomTooltip
                                txtClass="__tooltipTxt_bx"
                                cstStyle={{ maxWidth: "138px" }}
                              >
                                <p>{value}</p>
                              </CustomTooltip>
                            ) : (
                              <div className="__NottooltipTxt">
                                <p>{value}</p>
                              </div>
                            );
                          })()}
                        </td>
                        <td>
                          {(() => {
                            const name = indent?.consignor_id?.name || "Self";
                            const value = String(name);

                            return value.length > 20 ? (
                              <CustomTooltip
                                txtClass="__tooltipTxt_bx"
                                cstStyle={{ maxWidth: "138px" }}
                              >
                                <p>{value}</p>
                              </CustomTooltip>
                            ) : (
                              <div className="__NottooltipTxt">
                                <p>{value}</p>
                              </div>
                            );
                          })()}
                        </td>


                        <td>
                          {(() => {
                            const value = String(
                              planFromLoc(indent?.from_location) || ""
                            );

                            return value.length > 20 ? (
                              <CustomTooltip txtClass="__tooltipTxt_bx">
                                <p>{value}</p>
                              </CustomTooltip>
                            ) : (
                              <div className="__NottooltipTxt">
                                <p>{value || "-"}</p>
                              </div>
                            );
                          })()}
                        </td>

                        <td>
                          {(() => {
                            const value = String(
                              planToLoc(indent?.to_location) || ""
                            );

                            return value.length > 20 ? (
                              <CustomTooltip txtClass="__tooltipTxt_bx">
                                <p>{value}</p>
                              </CustomTooltip>
                            ) : (
                              <div className="__NottooltipTxt">
                                <p>{value || "-"}</p>
                              </div>
                            );
                          })()}
                        </td>

                        <td>
                          {indent?.branch_id?.branch ? (
                            indent?.branch_id?.branch
                          ) : (
                            <button
                              className="_branchPath_ind"
                              onClick={(e) => {
                                e.stopPropagation();
                                setIsOpenBranchModal(indent);
                              }}
                            >
                              + Add Branch
                            </button>
                          )}
                        </td>
                        <td>
                          {indent?.vehicle_id?.vehicle_no ? (
                            indent?.vehicle_id?.vehicle_no
                          ) : (
                            <button
                              className="_branchPath_ind"
                              onClick={(e) => {
                                e.stopPropagation();
                                setIsOpenVehicleModal(indent);
                              }}
                            >
                              + Add Vehicle
                            </button>
                          )}
                        </td>

                        <td>
                          <div className="_dateNtime">
                            <div className="__locationWid_bx">
                              <p className="_tblText_inDent">
                                {indent?.lorry_type_id?.lorry_type
                                  ? indent?.lorry_type_id?.lorry_type
                                  : "-"}
                              </p>
                            </div>
                            <p className="_lgtText_inDent">
                              {indent?.vehicle_type_id?.name
                                ? indent?.vehicle_type_id?.name
                                : "-"}
                            </p>
                          </div>
                        </td>

                        <td>
                          <div className="__locationWid_bx">
                            <p className="_tblText_inDent">
                              {indent?.material_type_id?.name
                                ? indent?.material_type_id?.name
                                : "-"}
                            </p>
                          </div>
                        </td>

                        <td>
                          <button
                            className="accordion-button _plnChev_btn collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#${indent?._id}`}
                            aria-expanded="false"
                            aria-controls={`${indent?._id}`}
                            onClick={(event) => {
                              event.stopPropagation();
                            }}
                          >
                            <IoChevronDownCircleOutline />
                          </button>
                        </td>
                      </tr>

                      <tr className="collapseRow">
                        <td colSpan={12}>
                          <div
                            id={`${indent?._id}`}
                            className="accordion-collapse collapse"
                            data-bs-parent="#indentTableAccordian"
                          >
                            <div className="accordion-body">
                              <>
                                {indent?.po_list?.map((po, index) => {
                                  return (
                                    <div className="_innrPO_trs" key={index}>
                                      <div className="_poDetails">
                                        <span>PO Date</span>
                                        <p>
                                          {po.po_date
                                            ? utils?.formatDateMonth(po.po_date)
                                            : "-"}
                                        </p>
                                      </div>

                                      <div className="_poDetails">
                                        <span>PO Number</span>
                                        <p>
                                          {po?.po_number ? po?.po_number : "-"}
                                        </p>
                                      </div>

                                      <div className="_poDetails">
                                        <span>Party</span>
                                        <p>
                                          {indent?.consignor_id
                                            ? indent?.consignor_id?.name
                                            : "Self"}
                                        </p>
                                      </div>

                                      <div className="_poDetails">
                                        <span>From Station</span>
                                        <CustomTooltip txtClass="__tooltipTxt_bx">
                                          {
                                            <p>
                                              {po?.from_location
                                                ? po?.from_location
                                                : "-"}
                                            </p>
                                          }
                                        </CustomTooltip>
                                      </div>

                                      <div className="_poDetails">
                                        <span>Pickup Address</span>
                                        <p>
                                          {po?.unit_id?.name
                                            ? po?.unit_id?.name
                                            : "-"}
                                        </p>
                                      </div>

                                      <div className="_poDetails">
                                        <span>To Station</span>
                                        <CustomTooltip txtClass="__tooltipTxt_bx">
                                          {
                                            <p>
                                              {po?.to_location
                                                ? po?.to_location
                                                : "-"}
                                            </p>
                                          }
                                        </CustomTooltip>
                                      </div>

                                      <div className="_poDetails">
                                        <span>Drop Address</span>
                                        <p>
                                          {po?.consignee_id?.name
                                            ? po?.consignee_id?.name
                                            : "-"}
                                        </p>
                                      </div>
                                    </div>
                                  );
                                })}
                              </>
                            </div>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td colSpan={11}>
                          <div className="d-flex justify-content-between gap-2">
                            <div className="_separateBxs">

                              {childsUser?.create === 1 && <>{indent?.plan_status == 1 && (
                                <button
                                  className="anime-btn _disPatch_ind"
                                  onClick={() => {
                                    handlePermissionCallTrip(indent?._id);
                                  }}
                                >
                                  Dispatch
                                </button>
                              )}</>}


                              {indent?.plan_status != 1 && indent?.trip_id && (
                                <button
                                  className="anime-btn _disPatch_ind"
                                  onClick={() => {
                                    navigate(
                                      `/trip/addtrip/dispatched/${indent?.trip_id?._id}`
                                    );
                                  }}
                                >
                                  Dispatched
                                </button>
                              )}

                              <span className="activeStatus">
                                {masterData?.plan_status[indent?.plan_status]}
                              </span>
                            </div>

                            <div className="d-flex">
                              {filter?.plan_status == 1 && (
                                <>
                                  {Number(indent?.is_allow_visibility) ? (
                                    <div className="_bidBtn_fx me-3">
                                      <div
                                        className="_sepBid_fx"
                                        onClick={() =>
                                          togglePlanDetail(indent, 0)
                                        }
                                      >
                                        <span className="_bidTxt">New Bid</span>
                                        <span className="_bidCount">
                                          {indent?.new_bid_count
                                            ? indent?.new_bid_count
                                            : 0}
                                        </span>
                                      </div>

                                      <div
                                        className="_sepBid_fx"
                                        onClick={() =>
                                          togglePlanDetail(indent, 1)
                                        }
                                      >
                                        <span className="_bidTxt">
                                          Accepted
                                        </span>
                                        <span className="_bidCount">
                                          {indent?.accepted_bid_count
                                            ? indent?.accepted_bid_count
                                            : 0}
                                        </span>
                                      </div>

                                      <div
                                        className="_sepBid_fx"
                                        onClick={() =>
                                          togglePlanDetail(indent, 3)
                                        }
                                      >
                                        <span className="_bidTxt">Closed</span>
                                        <span className="_bidCount">
                                          {indent?.closed_bid_count
                                            ? indent?.closed_bid_count
                                            : 0}
                                        </span>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                  <div
                                    className="_anvSwitcherNew form-check form-switch"
                                    style={{ width: "230px" }}
                                  >
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      name="visiblity"
                                      id={`actStatus-${indent._id}`}
                                      autoComplete="off"
                                      checked={Number(
                                        indent?.is_allow_visibility
                                      )}
                                      onChange={({
                                        target: { name, checked },
                                      }) => {
                                        updateMarketVisiblity(indent);
                                        let copyList = [...indentList];
                                        copyList[index].is_allow_visibility =
                                          checked;

                                        setIndentList(copyList);
                                      }}
                                    />
                                    <span>
                                      {Number(indent?.is_allow_visibility)
                                        ? " Market Visiblity Active"
                                        : " Market Visiblity Disabled"}
                                    </span>
                                  </div>
                                </>
                              )}

                              {filter?.plan_status == 1 && (
                                <div>
                                  <CustomSelect
                                    options={responseList}
                                    value={{
                                      label: `Status : ${indent?.responses
                                        ? responseList?.find(
                                          (i) =>
                                            i?.value == indent?.responses
                                        ).label
                                        : ""
                                        }`,
                                    }}
                                    onSelect={(data) => {
                                      chnagePlanStatus(data, indent);
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td colSpan={10}></td>
                      </tr>

                    </tbody>
                  );
                })}</> : <><tbody><tr>
                  <td colSpan={11} style={noTransactionStyle}>
                    No Data
                  </td>
                </tr></tbody></>}

              </table>
            </div>
          </div>
          {(indentList?.length > 0 && totalItems > 0) && <div className="paginationFt_avt ">
            {" "}
            <CustomPagination
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              currentPage={filter?.offset}
              onPageChange={handlePageChange}
            />
          </div>}
        </div>
      </div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas mdOffcanvas ${showAddIndent ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: showAddIndent ? "visible" : "hidden" }}
      >
        {showAddIndent && (
          <AddIndentModal
            isOpen={showAddIndent}
            onClose={(e) => {
              setIndentId("");
              setShowAddIndent(false);
            }}
            callList={callAllApi}
            id={indentId}
          />
        )}
      </div>
      <div className={showAddIndent ? "offBack_drop" : ""}></div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas xxlOffcanvas ${showPlanDetail ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: showPlanDetail ? "visible" : "hidden" }}
      >
        {showPlanDetail && (
          <IndentAndBidDetailModal
            isOpen={showPlanDetail}
            onClose={(e) => {
              setIndentId("");
              setShowPlanDetail(false);
            }}
            id={indentId}
            activeStatus={activeTabStatus}
          />
        )}
      </div>
      <div className={showPlanDetail ? "offBack_drop" : ""}></div>

      <div
        className={`offcanvas offcanvas-end common_offCanvas ${showFilterModal ? "show" : ""
          }`}
        tabIndex={-1}
        style={{ visibility: showFilterModal ? "visible" : "hidden" }}
      >
        {showFilterModal && (
          <MastersFilterModal
            isOpen={showFilterModal}
            onClose={() => setShowFilterModal(false)}
            filter={planFilter}
            setFilter={setPlanFilter}
            isShow={{
              dateRange: true,
              allBranch: true,
              consignor: true,
              fromLocation: true,
              toLocation: true,
              vehicle: true,
              search: false
            }}

            setFilterCount={setFilterCount}
            filterCount={filterCount}
            name="plan"
          />
        )}
      </div>
      <div className={showFilterModal ? "offBack_drop" : ""}></div>

      {showBackModal && (
        <ConfirmModalFor {...backModalProps}>
          <>
            <p className="_confirmPrx"> Do you really want Dispatch indent </p>
          </>
        </ConfirmModalFor>
      )}

      {isOpenBranchModal && <AddEditModal {...openBranchModal} />}

      {isOpenVehicleModal && <AddEditModal {...openVehicleModal} />}


      {modalConfig.isOpen && <EbillExtentionModal

        {...ebillExpProps}

      />}
    </>
  );
};

export default Plan;
